var _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChartPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 213,
    viewBox: "0 0 225 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 208,
    width: 27,
    height: 5,
    rx: 2.5,
    fill: "#BCBEC2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 208,
    width: 27,
    height: 5,
    rx: 2.5,
    fill: "#BCBEC2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 208,
    width: 26,
    height: 5,
    rx: 2.5,
    fill: "#BCBEC2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 208,
    width: 26,
    height: 5,
    rx: 2.5,
    fill: "#BCBEC2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 41.7932,
    x2: 225,
    y2: 41.7932,
    stroke: "#CBCBCB",
    strokeWidth: 0.413664
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 111.793,
    x2: 225,
    y2: 111.793,
    stroke: "#CBCBCB",
    strokeWidth: 0.413664
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 188.793,
    x2: 225,
    y2: 188.793,
    stroke: "#CBCBCB",
    strokeWidth: 0.413664
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 196.104,
    width: 152.642,
    height: 24.8198,
    rx: 12.4099,
    transform: "rotate(-90 15 196.104)",
    fill: "#98A1AA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 196,
    width: 164,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 77 196)",
    fill: "#98A1AA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 196,
    width: 74.4595,
    height: 24.8198,
    rx: 12.4099,
    transform: "rotate(-90 15 196)",
    fill: "#373D43"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 196,
    width: 102,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 77 196)",
    fill: "#373D43"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 196,
    width: 135,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 127 196)",
    fill: "#98A1AA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 196,
    width: 196,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 185 196)",
    fill: "#98A1AA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 196,
    width: 58,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 127 196)",
    fill: "#373D43"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 196,
    width: 94,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 185 196)",
    fill: "#373D43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartPreview);
export default __webpack_public_path__ + "static/media/barChartPreview.661e1d1a2938a828492447624e266966.svg";
export { ForwardRef as ReactComponent };